const DEFAULT_API_URL = "https://api.booksaw.uz";

export const serverApi: string = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(/\/+$/, "");

export const Messages = {
  error1: "Something went wrong!",
  error2: "Please login first!",
  error3: "Please fullfill all inspect!",
  error4: "Message is empeaty!",
  error5: "Only images with jpeg, jpg, png format allowed!",
};
